import React from 'react';

export interface TextProps {
	align?: React.CSSProperties['textAlign'];
	bold?: boolean;
	extrabold?: boolean;
	color?: React.CSSProperties['color'];
	italic?: boolean;
	lineHeight?: React.CSSProperties['lineHeight'];
	lowercase?: boolean;
	size?: React.CSSProperties['fontSize'];
	uppercase?: boolean;
}

const styleFromTextProps = (props: TextProps) => {
	const style: React.CSSProperties = {
		color: props.color,
		fontSize: props.size,
		lineHeight: props.lineHeight,
		textAlign: props.align,
	};

	if (props.uppercase) {
		style.textTransform = 'uppercase';
	} else if (props.lowercase) {
		style.textTransform = 'lowercase';
	}

	if (props.bold) {
		style.fontWeight = 'bold';
	}

	if (props.extrabold) {
		style.fontWeight = 900;
	}

	if (props.italic) {
		style.fontStyle = 'italic';
	}

	return style;
};

const Text = (props: React.PropsWithChildren<TextProps & { style?: React.CSSProperties; }>) => {
	return (
		<span style={{ ...styleFromTextProps(props), ...props.style }}>
			{props.children}
		</span>
	);
};

Text.styleFromTextProps = styleFromTextProps;

export default Text;
